<!-- ======= Team Section ======= -->
<section id="team" class="team section-bg" style="padding-top: 170px;">
    <div class="container" data-aos="fade-up">
      <ngx-skeleton-loader count="5" appearance="line" *ngIf="users===undefined"></ngx-skeleton-loader>
        <!-- <ngx-shimmer-loading [shape]="'rect'" [width]="'100%'" [height]="'200px'" *ngIf="users===undefined"></ngx-shimmer-loading> -->
        <div class="row" *ngIf="users">
            <div class="col-lg-4" data-aos="fade-right" data-aos-delay="300" style="padding-top: 10px;">
                <img [src]="'data:image/png;base64,'+users.avatar" class="img-fluid" style="width: 100%;height: 330px;" alt=""/>
                <div style="background-color: #032d57;padding: 20px;color: white;">
                    <a href="mailto:{{users.email}}" style="cursor: pointer;color:white;"><i class="fa fa-envelope-o"></i>&nbsp;&nbsp;{{users.email}}</a>
                </div>
            </div>
            <div class="col-lg-8"  data-aos="fade-left" data-aos-delay="300" style="padding-top: 10px;">
                <h1 class="theme_color" >
                    <strong>{{users.name}}</strong>
                </h1>

                <p class="theme_color fontSize" [innerHtml]="users.smalldescription">
                </p>

                <p class="theme_color fontSize" [innerHtml]="users.fulldescription">
                </p>
            </div>
            

        </div>
    </div>


    <!-- <div class="container-fluid" data-aos="fade-up">
      <div class="row" *ngIf="users">
        <div class="col-lg-12 mt-12" data-aos="fade-up" data-aos-delay="100" style="cursor: pointer;">
          <div class="member d-flex align-items-start">
            <div><img [src]="'data:image/png;base64,'+users.avatar" class="img-fluid" alt=""></div>
            <div class="member-info">
              <h4>{{users.name}}</h4>
              <span>{{users.designation}}</span>
              <div class="social">
                <a href="mailto:{{users.email}}"><i class="fa fa-envelope-o"></i></a><label style="margin:10px;">{{users.email}}</label>                
              </div>              
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </section><!-- End Team Section -->